import { LotOfCash } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconLotOfCash12Line = createIcon(LotOfCash, 12, "Line");
export const IconLotOfCash16Line = createIcon(LotOfCash, 16, "Line");
export const IconLotOfCash20Line = createIcon(LotOfCash, 20, "Line");
export const IconLotOfCash24Line = createIcon(LotOfCash, 24, "Line");
export const IconLotOfCash32Line = createIcon(LotOfCash, 32, "Line");
export const IconLotOfCash48Line = createIcon(LotOfCash, 48, "Line");
export const IconLotOfCash64Line = createIcon(LotOfCash, 64, "Line");
